import DeleteIcon from 'material-ui/svg-icons/action/delete';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';
import { ModuleDialogs } from '../../constants/Dialogs';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DoneIcon from 'material-ui/svg-icons/action/done';
import CancelledIcon from 'material-ui/svg-icons/content/clear';
import WaitingIcon from 'material-ui/svg-icons/action/schedule';
import EnrolledIcon from 'material-ui/svg-icons/action/assignment';
import CompletedIcon from 'material-ui/svg-icons/action/done';
import DidNotAttendIcon from 'material-ui/svg-icons/content/clear';


import DialogActions from '../../actions/DialogActionCreator';

const iconList = {
    waiting:    <WaitingIcon />,
    attending:  <EnrolledIcon />,
    attended:   <CompletedIcon />
};

class ModuleEventAttendanceTableRow extends Component {

    componentDidMount() {
        this.onEdit = this.onEdit.bind(this);
    }

    onEdit() {
        DialogActions.open(ModuleDialogs.MODULE_EVENT_SCORE, Object.assign({}, this.props.row, this.state));
    }

    getActions() {
        const { row } = this.props;
        return [
            <IconButton key="edit" onClick={this.onEdit} tooltip="edit status" disabled={row.loading}>
                <EditIcon color={statusColours.medium} />
            </IconButton>
        ];
    }

    render() {
        const { row, children, ...others } = this.props;
        const name = `${row.firstName || ''} ${row.lastName || ''}`.trim();
        const actions = this.getActions();
        const score = (row.score || (row.score === 0 ? row.score : null));


        let status = '';

        switch(this.props.row.attendanceStatus) {

            case'cancelled':
                status = <CancelledIcon color={statusColours.medium}/>;
                break;

            case 'did_not_attend':
                status = <DidNotAttendIcon color={statusColours.medium}/>;
                break;

            case 'waiting':
                status = <WaitingIcon color={statusColours.medium}/>;
                break;

            case 'attended':
                status = <DoneIcon color={statusColours.primary}/>;
                break;

            default:
                break;

        }

        return (
            <TableRow {...others} >
                { children && children[0] }
                <TableRowColumn><Link to={`/dashboard/user/${row.userId}`} >{name}</Link></TableRowColumn>
                <TableRowColumn>{status}</TableRowColumn>
                <TableRowColumn className="tbl-td-number" style={{width: '4em'}}>{score}</TableRowColumn>
                <TableRowColumn className="tbl-td-actions">{actions}</TableRowColumn>
            </TableRow>
        );
    }

}

ModuleEventAttendanceTableRow.propTypes = {
    row:        PropTypes.shape({
        firstName:          PropTypes.string,
        lastName:           PropTypes.string,
        status:             PropTypes.string,
        attendanceStatus:   PropTypes.string,
        moduleType:         PropTypes.string
    }),

    rowProps:   PropTypes.object
};

ModuleEventAttendanceTableRow.contextTypes = {
    auth:       PropTypes.object
};

export default ModuleEventAttendanceTableRow;
